export { default as MapButtonActionForAside } from './MapButtonActionForAside'
